import { BaseObject } from "@adgate/common/types/base-object.type";

export class Language extends BaseObject
{
    public static PORTUGUESE: number = 2;
}